import { createReducer, on } from "@ngrx/store";
import { TokenConnectedItem, TokenItem } from "../../interfaces/item/TokenItem.interface";
import { userActions } from "./userData.actions";

export interface UserState {
    user: TokenItem | TokenConnectedItem | null;
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: UserState = {
    user: null,
    loading: true
}

export const userReducer = createReducer(
    initialeState,
    on(
        userActions["[User-API]ResetUser"], state => ({
            ...state,
            user: null
        })
    ),
    on(
        userActions["[User]-AddUser"], (state, res) => ({
            ...state,
            loading: false,
            user: res
        })
    ),
)